import { Button, Card, CardHeader, CardBody, CardFooter, Image } from '@nextui-org/react'
import { useNavigate } from 'react-router-dom'
import React from 'react'
import { useSocketContextData } from 'src/context/socket'
import { Icon } from '@iconify/react'

export default function PersonalizePowerdocsModal({
  isOpen,
  onOpenChange,
}: {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
}) {
  const navigate = useNavigate()
  const { io } = useSocketContextData()
  const onClose = () => onOpenChange(false);
  return (
    <div className="cursor-pointer z-40 invisible md:visible" onClick={() => {
      navigate('/settings/powerdocs')
      onClose()
    }}>
      <Card className="w-full max-w-[520px] h-fit absolute right-5 bottom-5 bg-[#fff]">
        <Button
          isIconOnly
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          className="absolute right-2 top-2 z-20"
          radius="full"
          size="sm"
          variant="light"
        >
          <Icon icon="iconamoon:close-thin" width={24} className="text-default-800" />
        </Button>
        <CardBody className="flex flex-row flex-wrap p-0 sm:flex-nowrap">
          <Image
            removeWrapper
            alt="Personalize Powerdocs AI"
            className="h-auto w-full flex-none object-cover object-top md:w-48 p-5"
            src="/img/modal-modify-powerdocs-ai.png"
          />
          <div className="pl-1 pr-4 py-5">
            <div className="flex flex-col gap-2 pt-2 text-small">
              <div className="flex flex-col gap-0">
                <span className="text-tiny font-semibold text-secondary uppercase">Set it and forget it</span>
                <div className="text-lg font-semibold">Personalize Powerdocs AI</div>
              </div>
              <p>Customize your default settings so Powerdocs generates your documents with perfection.</p>
              <p>Save time and work extremely fast and effectively — <span className="underline">try it now</span></p>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  )
}